import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

export interface Mantenimiento {
  estado: number;
  conductorNombre: any;
  cedula_conductor: any;
  id?: number;
  fecha?: string;
  placa?: string;
  km?: number;
  tipo?: string;
  taller?: string;
  servicio?: string;
  accion?: string;
  factura?: string;
  vrpagos?: string;
  forma?: string;
  conductor?: string;
  observacion?: string;
  registro?: string;
  ip?: string;
}

export interface Mantenimiento {
  estado: number;
  conductorNombre: any;
  cedula_conductor: any;

  id?: number;
  fecha?: string;
  placa?: string;
  km?: number;

  tipo?: string;
  taller?: string;
  servicio?: string;
  accion?: string;

  factura?: string;
  
  forma?: string;
  conductor?: string;
  observacion?: string;
  registro?: string;
  ip?: string;

  tipoMantenimiento?: {
    codigo?: string;
    nombre?: string;
    descripcion?: string;
  };

  tipoServicio?: {
    sistema?: string;
    parte?: string;
    tipo_de_mantenimiento?: string;
  };

  tipoAccion?: {
    descripcion?: string;
  };

  formaPago?: {
    descripcion?: string;
  };

  vehiculo?: {
    placa?: string;
    marca?: number;
    modelo?: number;
    capacidad?: number;
  };

  soporte?: string;
}

export interface Vehiculo {
  placa: string;
  modelo: string;
  color: string;
  matricula: string;
  fechalict: string;
  cilindraje: number;
  motor: string;
  serie: string;
  linea: string;
  organismo: string;
  capacidad: string;
  chasis: string;
}

export interface DocumentoMantenimiento {
  id: number;
  documento: string;
}

export interface RespuestaMantenimientos {
  codigo: number;
  cantidadVehiculos: number;
  cantidadMantenimientos: number;
  costoTotal: number;
  costoPromedio: number;
  filtros: {
    placas: string[];
    fechaInicial: string;
    fechaFinal: string;
  };
  vehiculos: {
    placa: string;
    totalMantenimientos: number;
    costoTotal: number;
    costoPromedio: number;
    mantenimientos: Mantenimiento[];
  }[];
  mensaje: string;
}

@Injectable({
  providedIn: "root",
})
export class MantenimientoService {
   private apiUrl =  `${environment.apiUrl}/api/mantenimientos`; 
    

  constructor(private http: HttpClient) {}

  private getAuthHeaders(): HttpHeaders {
    return new HttpHeaders({
      'Content-Type': 'application/json'
    });
  }

  getAll(): Observable<Mantenimiento[]> {
    return this.http.get<Mantenimiento[]>(this.apiUrl, {
      withCredentials: true
    });
  }

  getById(id: number): Observable<Mantenimiento> {
    return this.http.get<Mantenimiento>(`${this.apiUrl}/${id}`, {
      withCredentials: true
    });
  }

  createMantenimiento(mantenimiento: any): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}`, mantenimiento, {
      headers: this.getAuthHeaders(),
      withCredentials: true
    });
  }

  update(id: number, data: Mantenimiento): Observable<Mantenimiento> {
    return this.http.put<Mantenimiento>(`${this.apiUrl}/${id}`, data, {
      headers: this.getAuthHeaders(),
      withCredentials: true
    });
  }

  delete(id: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${id}`, {
      withCredentials: true
    });
  }

buscarMantenimientosPorFiltros(
  placas: string[] = [],
  fechaInicial: string,
  fechaFinal: string
): Observable<RespuestaMantenimientos> {

  const body = {
    placas: placas ?? [],
    fechaInicial: fechaInicial.substring(0, 10),
    fechaFinal: fechaFinal.substring(0, 10)
  };
  return this.http.post<RespuestaMantenimientos>(
    `${this.apiUrl}/filtros`,
    body,
    {
      headers: this.getAuthHeaders(),
      withCredentials: true
    }
  );
}

  inactivar(id: number): Observable<any> {
    return this.http.put(
      `${this.apiUrl}/estado/${id}`,
      {}, // No se envía cuerpo, solo se actualiza el estado a 0 desde backend
      { withCredentials: true }
    );
  }

  editar(id: number, data: Partial<Mantenimiento>): Observable<any> {
    return this.http.put(`${this.apiUrl}/editar/${id}`, data, {
      headers: this.getAuthHeaders(),
      withCredentials: true
    });
  }
}



